




































import { Component, Vue } from 'vue-property-decorator';
import NavBar from '@/components/NavBar.vue';
import TabBar from '@/components/TabBar.vue';
import Button from '@/components/Button.vue';
import Loader from '@/components/Loader.vue';
import { namespace } from 'vuex-class';
import Booking from '@/types/taxcard/Booking';
import { NamedRoutes } from '@/routes/routes';
import CreditcardForm from '@/components/payment-forms/CreditcardForm.vue';
import SepaForm from '@/components/payment-forms/SepaForm.vue';
import PaymentData from '@/types/store/checkout/PaymentData';
import CheckoutApi from '@/app/api/CheckoutApi';
import moment from 'moment';
import i18next from 'i18next';

const BookingModule = namespace('booking');
const CREDITCARDS = ['visa', 'master'];

@Component({
  components: {
    NavBar,
    TabBar,
    Button,
    Loader,
    CreditcardForm,
    SepaForm,
  },
})
export default class CheckoutPaymentDetailsView extends Vue {
  @BookingModule.Getter
  public currentBooking!: Booking;

  @BookingModule.Getter
  public currentOrderId!: string;

  @BookingModule.Getter
  public currentPaymentMethod!: string;

  @BookingModule.Getter
  public downcasedPaymentMethod!: string;

  public paymentIsLoading: Boolean = false;

  public iframeUrl: string = '';

  public paymentData: PaymentData = {
    paymentMethod: '',
    orderId: '',
    owner: '',
    creditCardData: {},
    iban: '',
    bic: '',
    firstname: '',
    lastname: '',
    phone: '',
    email: '',
    street: '',
    street_number: '',
    zip: '',
    city: '',
    country: '',
    birthday: moment(),
  };

  public async mounted() {
    if (!this.currentBooking || !this.currentPaymentMethod) {
      this.$router.push({ name: NamedRoutes.checkout });
    } else {
      this.$trackEvent('checkout', 'payment-proceed', 'entered');
      this.paymentData.paymentMethod = this.currentPaymentMethod;
      this.paymentData.orderId = this.currentOrderId;
      const wrapperElement = document.querySelector('.navbar');
      wrapperElement && wrapperElement.scrollIntoView();
      if (this.renderPaypalFrame) this.confirmPayment();
    }
  }

  private updateData(data: Object) {
    Object.entries(data).forEach(([key, value]) => {
      // @ts-ignore
      this.paymentData[key] = value;
    });
  }

  private async confirmPayment() {
    this.$trackEvent('checkout', 'payment-confirm');
    this.paymentIsLoading = true;
    await CheckoutApi.directPayment(this.paymentData)
      .then(response => {
        this.$trackEvent('checkout', 'payment-confirm', 'success');
        if (response.iframe_url) {
          this.iframeUrl = response.iframe_url;
        } else {
          this.renderVerificationView(response);
        }
      })
      .catch(error => {
        this.$trackEvent('checkout', 'payment-confirm', 'error');
        const remoteError = error.response.data.remoteError;
        let title = remoteError ? remoteError.error_user : 'Fehler';
        let message = remoteError ? remoteError.error_details : '';
        if (message && message.includes('contract (E4400)')) {
          this.$router.push({ name: NamedRoutes.checkout, query: { error: 'payment-failed-redirect' } });
          return;
        }
        if (title && title.includes('Code 3022')) {
          title = i18next.t('checkout.errors.declined.title');
          message = i18next.t('checkout.errors.declined.message');
        }
        this.$store.commit('openOverlay', {
          overlayName: 'Info',
          overlayData: { title, message },
        });
      });
    this.paymentIsLoading = false;
  }

  renderVerificationView(response: any) {
    this.$router.push({
      name: NamedRoutes.checkoutPaymentVerify,
      query: {
        id: response.id,
        resourcePath: 'notset',
        orderId: this.paymentData.orderId,
        paymentMethod: this.paymentData.paymentMethod,
      },
    });
  }

  get renderCreditCardForm(): Boolean {
    return CREDITCARDS.includes(this.downcasedPaymentMethod);
  }

  get renderSepaForm(): Boolean {
    return this.downcasedPaymentMethod.includes('sepa');
  }

  get renderPaypalFrame(): Boolean {
    return this.downcasedPaymentMethod == 'paypal';
  }
}
